var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{attrs:{"id":"model-tiny-mce"}},[_c('p',{staticClass:"model-tiny-mce__label"},[_vm._v(_vm._s(_vm.label))]),_c('div',{ref:"root",staticClass:"model-tiny-mce__editor",class:{ 'model-tiny-mce__editor--error': _vm.error }},[_c('Editor',{attrs:{"api-key":"no-api-key","tinymce-script-src":_vm.tinymceScriptSrc,"init":{
        toolbar_mode: 'sliding',
        plugins: _vm.plugins,
        language: 'ru',
        toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table mergetags | addcomment showcomments | spellcheckdialog a11ycheck typography | align lineheight | checklist numlist bullist indent outdent | emoticons charmap | removeformat',
        tinycomments_mode: 'embedded',
        tinycomments_author: 'Author name',
        images_upload_handler: _vm.fileUpload,
        mergetags_list: [
          { value: 'First.Name', title: 'First Name' },
          { value: 'Email', title: 'Email' },
        ],
      },"initial-value":""},model:{value:(_vm.dataValue),callback:function ($$v) {_vm.dataValue=$$v},expression:"dataValue"}})],1),(_vm.error)?_c('div',{staticClass:"model-tiny-mce__error"},[_vm._v("\n    "+_vm._s(_vm.errorMessage)+"\n  ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }